// app/LayoutContent.tsx
"use client";

import { ReactNode } from "react";
import { useShellMode } from "@/app/components/sidebar";

export default function LayoutContent({ children }: { children: ReactNode }) {
  const shellMode = useShellMode();

  return (
    <div className="flex h-dvh">
      <main
        className={`
          flex-1 overflow-y-auto
          ${shellMode === "tablet" ? "pb-[calc(5.25rem+env(safe-area-inset-bottom))]" : ""}
        `}
      >
        {children}
      </main>
    </div>
  );
}
